import { render, staticRenderFns } from "./oddsanalysis.vue?vue&type=template&id=f140c99e&scoped=true"
import script from "./oddsanalysis.vue?vue&type=script&lang=js"
export * from "./oddsanalysis.vue?vue&type=script&lang=js"
import style0 from "./oddsanalysis.vue?vue&type=style&index=0&id=f140c99e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f140c99e",
  null
  
)

export default component.exports